
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const SubscriptionCTA = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-chapterly-dark-purple to-chapterly-purple text-white grow flex flex-col justify-center">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">Get unlimited access to premium content</h2>
        <p className="text-base md:text-lg mb-6 md:mb-8 max-w-2xl mx-auto">
          Unlock all premium episodes, support your favorite authors, 
          and enjoy an ad-free reading experience.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
          <Button 
            size="lg" 
            className="bg-white text-chapterly-purple hover:bg-gray-100 font-medium w-full sm:w-auto"
            asChild
          >
            <Link to="/subscription">Subscribe Now</Link>
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="border-white text-white bg-transparent hover:bg-white hover:text-chapterly-purple font-medium w-full sm:w-auto"
            asChild
          >
            <Link to="/subscription">Learn More</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
